import React, { useState } from "react"
import Hamburger from '../components/Hamburger';

export default function BabyPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    
    return (
        <div className="baby-page">
            <nav className="navbar">
                <Hamburger open={sidebarOpen} setOpen={setSidebarOpen} />
            </nav>
            <div className="text-center py-5">
                <div className="container">
                    <h1 className="mb-4">🍼 Baby Registry 🍼</h1>
                    <div className="card mx-auto border border-dark border-2 rounded-3" style={{maxWidth: '600px'}}>
                        <div className="card-body p-5">
                            <h3 className="card-title mb-4">Help Us Prepare for our Baby!</h3>
                            <p className="card-text mb-4">
                                We're so excited to welcome our little one and would love your help in preparing for this amazing journey! 
                            </p>
                            <a 
                                href="https://www.amazon.com/baby-reg/sage-lamonica-december-2025-cliftonpark/1V7CERZ9TDHYH?ref_=cm_sw_r_mwn_dp_Z8R2RPPRSHJRNVHM70Q2&language=en-US" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="btn btn-primary btn-lg"
                            >
                                Click Here to Go to Our Registry
                            </a>
                            <p className="text-muted mt-3 small">
                                Thank you for helping us get ready for our bundle of joy! ❤️
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}